import { PortfolioAsset as PortfolioAssetRaw } from '@services/contentful/types';
import { Entry } from 'contentful';
import { CapitalStackColor, IconListItem, InfoItem, PortfolioAsset } from 'src/apps/portfolio/types';

export const mapField = (key: keyof PortfolioAssetRaw, asset: PortfolioAsset, request: Entry<PortfolioAssetRaw>) => {
  switch (key) {
    case 'location':
      asset.mapInformation = {
        location: {
          lat: request.fields.location.lat,
          long: request.fields.location.lon,
        },
      };
      break;
    case 'description':
      asset.description = request.fields.description;

      break;
    case 'features':
      asset.assetFeatures = {
        heading: request.fields.features.fields.heading,
        items: request.fields.features.fields.items.map((item) => {
          return item.fields as IconListItem;
        }),
      };
      break;
    case 'topEmployers':
      asset.topEmployers = {
        employersImage: request.fields.topEmployers.fields.employersImage.fields,
        heading: request.fields.topEmployers.fields.heading,
      };
      break;
    case 'primaryPartner':
      asset.primaryPartner = {
        description: request.fields.primaryPartner.fields.partnerDescription,
        heading: request.fields.primaryPartner.fields.heading,
        logo: request.fields.primaryPartner.fields.partnerImage.fields,
      };
      break;

    case 'assetDetails':
      asset.assetDetails = {
        disclaimer: request.fields.assetDetails.fields.tableDisclaimer,
        heading: request.fields.assetDetails.fields.heading,
        rows: request.fields.assetDetails.fields.items.map((item: { fields: InfoItem }) => item.fields),
      };

      break;
    case 'capitalStack':
      asset.capitalStack = {
        heading: request.fields.capitalStack.fields.heading,
        parts: request.fields.capitalStack.fields.capitalStackParts.map((part) => {
          return {
            color: part.fields.color as CapitalStackColor,
            debtAmount: part.fields.debtAmount,
            debtType: part.fields.debtType,
            percentage: part.fields.percentage,
          };
        }),

        total: request.fields.capitalStack.fields.totalCapitalization,
      };

      break;
    case 'timeline':
      asset.timeLine = {
        events: request.fields.timeline.fields.events.map((event) => event.fields),
        heading: request.fields.timeline.fields.heading,
      };
      break;
    case 'businessPlan':
      asset.businessPlan = {
        heading: request.fields.businessPlan.fields.heading,
        items: request.fields.businessPlan.fields.items.map((item) => item.fields as IconListItem),
      };
      break;
    case 'locationInfo':
      asset.locationInfo = {
        disclaimer: request.fields.locationInfo.fields.tableDisclaimer,
        heading: request.fields.locationInfo.fields.heading,
        rows: request.fields.locationInfo.fields.items.map((item: { fields: InfoItem }) => item.fields),
      };
      break;
    case 'investmentOverview':
      asset.investmentOverview = {
        disclaimer: request.fields.investmentOverview.fields.tableDisclaimer,
        heading: request.fields.investmentOverview.fields.heading,
        rows: request.fields.investmentOverview.fields.items.map((item: { fields: InfoItem }) => item.fields),
      };
      break;
    case 'risksAndMitigants':
      asset.risksAndMitigants = {
        heading: request.fields.risksAndMitigants.fields.heading,
        items: request.fields.risksAndMitigants.fields.risks.map((risk) => {
          return {
            heading: risk.fields.risk,
            mitigations: risk.fields.mitigationList ? (risk.fields.mitigationList as string[]) : [],
            riskDescription: risk.fields.riskDescription,
          };
        }),
      };
      break;
    case 'propertyValuation':
      asset.propertyValuation = {
        disclaimer: request.fields.propertyValuation.fields.tableDisclaimer,
        heading: request.fields.propertyValuation.fields.heading,
        rows: request.fields.propertyValuation.fields.items.map((item: { fields: InfoItem }) => item.fields),
      };
      break;
    case 'images':
      asset.images = request.fields.images.map((image) => {
        return image.fields;
      });
      break;
    case 'marketingText':
      asset.marketingText = request.fields.marketingText.map((item) => ({
        additionalParagraph1: item.fields.additionalMarketingParagraph1,
        additionalParagraph2: item.fields.additionalMarketingParagraph2,
        heading: item.fields.heading,
        marketingParagraph: item.fields.marketingParagraph,
      }));
      break;
    case 'loanDetails':
      asset.loanDetails = request.fields.loanDetails.fields;
      break;
    case 'ctaUrl':
      asset.ctaUrl = request.fields.ctaUrl;
      break;
    default:
      break;
  }
};
